import { render, staticRenderFns } from "./buy-request-remove.vue?vue&type=template&id=c2df08d4&scoped=true"
import script from "./buy-request-remove.vue?vue&type=script&lang=js"
export * from "./buy-request-remove.vue?vue&type=script&lang=js"
import style0 from "./buy-request-remove.vue?vue&type=style&index=0&id=c2df08d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2df08d4",
  null
  
)

export default component.exports